import type { IAndroidAmbientLightStatus } from '@/helpers/parseAndroidAmbientLight'
import { parseAndroidAmbientLightStatus } from '@/helpers/parseAndroidAmbientLight'
import { isTauriRuntime } from '@/helpers/resolvedPlayerAppVersion'
import { getPlatform } from '@/platform'

export type { IAndroidAmbientLightStatus }

function isAndroidTauri(): boolean {
  return isTauriRuntime() && getPlatform() === 'android'
}

/** Android-only: sensor support and, while sampling, the latest lux reading. */
export async function fetchAndroidAmbientLightStatus(): Promise<IAndroidAmbientLightStatus | null> {
  if (!isAndroidTauri()) {
    return null
  }
  try {
    const { invoke } = await import('@tauri-apps/api/core')
    return parseAndroidAmbientLightStatus(await invoke<unknown>('plugin:lucimark-android|getAmbientLightStatus'))
  }
  catch {
    return null
  }
}

/** Android-only: starts light sampling. Resolves false when there is no sensor or the call failed. */
export async function startAndroidAmbientLight(): Promise<boolean> {
  if (!isAndroidTauri()) {
    return false
  }
  try {
    const { invoke } = await import('@tauri-apps/api/core')
    const res = await invoke<{ started?: boolean }>('plugin:lucimark-android|startAmbientLight')
    return res?.started === true
  }
  catch {
    return false
  }
}

export async function stopAndroidAmbientLight(): Promise<void> {
  if (!isAndroidTauri()) {
    return
  }
  try {
    const { invoke } = await import('@tauri-apps/api/core')
    await invoke('plugin:lucimark-android|stopAmbientLight')
  }
  catch {
    // best effort: the listener is also dropped when the process ends
  }
}
